import React from 'react';
import { NuLifeSpanCardFront } from './Cards/NuLifeSpanCard';
import { CVSCardFront } from './Cards/CVSCard';
import { WalmartCardFront } from './Cards/WalmartCard';

export default function CardFront({ cardData, groupData, PrimaryGn, mId, bin, pcn }) {
    const cardType = cardData?.classnames;
    
    // Determine which props to use
    const memberId = mId || cardData?.mId || '';
    const binNumber = bin || cardData?.bin || '';
    const pcnNumber = pcn || cardData?.pcn || '';
    const groupNumber = PrimaryGn || groupData?.groupnumber || '';
    
    if (cardType === 'cvs_card') {
        return (
            <CVSCardFront 
                bin={binNumber}
                pcn={pcnNumber}
                groupNumber={groupNumber}
                memberId={memberId}
            />
        );
    }
    
    if (cardType === 'walmart_card') {
        return (
            <WalmartCardFront 
                bin={binNumber}
                pcn={pcnNumber}
                groupNumber={groupNumber}
                memberId={memberId}
            />
        );
    }
    
    // Default: NuLifeSpan Rx card
    return (
        <NuLifeSpanCardFront 
            bin={binNumber}
            pcn={pcnNumber}
            groupNumber={groupNumber}
            memberId={memberId}
        />
    );
}
